define("shared/components/shared/ui/banner", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--page__banner">
    {{#unless @isHidden}}
  
      <div class={{if @className @className}}>
  
        {{#if @text}}
  
          <p class="u--text--light u--text--md u--m__b__0">
            {{@text}}
  
            {{#if this.showTooltip}}
              <Shared::Ui::IconTooltip @tooltip={{t "analytics.tooltips.instagram_business_profile"}} />
            {{/if}}
  
            {{#if @link}}
              <a
                class={{if @showButton "o--btn o--btn--default u--m__l"}}
                href={{@link}}
                rel="noopener noreferrer"
                target="_blank"
                title={{if @title @title}}
              >
                {{@linkText}}
              </a>
            {{/if}}
  
            {{#if @linkTo}}
              <LinkTo
                @route={{@linkTo}}
                class={{if @showButton "o--btn o--btn--default u--m__l"}}
                title={{if @title @title}}
              >
                {{@linkText}}
              </LinkTo>
            {{/if}}
  
            {{#if @actionMethod}}
              <Shared::Ui::Button
                @onClick={{@actionMethod}}
                @text={{@linkText}}
                @variant={{if @showButton "default" "actionLink"}}
                class={{if @showButton "u--m__l"}}
                title={{if @title @title}}
              />
            {{/if}}
  
          </p>
  
        {{/if}}
  
      </div>
  
      {{yield}}
  
    {{/unless}}
  </div>
  */
  {
    "id": "IJ/ulLUy",
    "block": "[[[10,0],[14,0,\"o--page__banner\"],[12],[1,\"\\n\"],[41,[51,[30,1]],[[[1,\"\\n    \"],[10,0],[15,0,[52,[30,2],[30,2]]],[12],[1,\"\\n\\n\"],[41,[30,3],[[[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--text--md u--m__b__0\"],[12],[1,\"\\n          \"],[1,[30,3]],[1,\"\\n\\n\"],[41,[30,0,[\"showTooltip\"]],[[[1,\"            \"],[8,[39,2],null,[[\"@tooltip\"],[[28,[37,3],[\"analytics.tooltips.instagram_business_profile\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,4],[[[1,\"            \"],[10,3],[15,0,[52,[30,5],\"o--btn o--btn--default u--m__l\"]],[15,6,[30,4]],[14,\"rel\",\"noopener noreferrer\"],[14,\"target\",\"_blank\"],[15,\"title\",[52,[30,6],[30,6]]],[12],[1,\"\\n              \"],[1,[30,7]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,8],[[[1,\"            \"],[8,[39,4],[[16,0,[52,[30,5],\"o--btn o--btn--default u--m__l\"]],[16,\"title\",[52,[30,6],[30,6]]]],[[\"@route\"],[[30,8]]],[[\"default\"],[[[[1,\"\\n              \"],[1,[30,7]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,9],[[[1,\"            \"],[8,[39,5],[[16,0,[52,[30,5],\"u--m__l\"]],[16,\"title\",[52,[30,6],[30,6]]]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,9],[30,7],[52,[30,5],\"default\",\"actionLink\"]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n\"]],[]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[18,10,null],[1,\"\\n\\n\"]],[]],null],[13]],[\"@isHidden\",\"@className\",\"@text\",\"@link\",\"@showButton\",\"@title\",\"@linkText\",\"@linkTo\",\"@actionMethod\",\"&default\"],false,[\"unless\",\"if\",\"shared/ui/icon-tooltip\",\"t\",\"link-to\",\"shared/ui/button\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/banner.hbs",
    "isStrictMode": false
  });
  // Note: If you provide link or linkTo you need to provide linkText as well
  let BannerComponent = _exports.default = (_class = class BannerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
    }
    get showTooltip() {
      const str = this.args.text;
      const subStr = this.intl.t('analytics.general.instagram_business_profile');
      return !!str?.includes(subStr);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BannerComponent);
});